import { type OutputData } from "@editorjs/editorjs";

const HTML_TAG = /<[^>]*>/g;
const HTML_ENTITY = /&(nbsp|amp|lt|gt|quot|#39);/g;
const ENTITIES: Record<string, string> = {
  "#39": "'",
  amp: "&",
  gt: ">",
  lt: "<",
  nbsp: " ",
  quot: '"',
};

const stripHtml = (value: string) =>
  value
    .replace(HTML_TAG, " ")
    .replace(HTML_ENTITY, (_match, entity: string) => ENTITIES[entity] ?? " ")
    .replace(/[^\S\n]+/g, " ")
    .trim();

const blockToText = (block: OutputData["blocks"][number]): string => {
  const data = block.data as {
    text?: string;
    caption?: string;
    items?: (string | { content?: string })[];
    code?: string;
    title?: string;
    message?: string;
  };

  const items = data.items
    ?.map((item) => (typeof item === "string" ? item : (item?.content ?? "")))
    .filter(Boolean)
    .join(", ");

  return [data.title, data.message, data.text, items, data.caption].filter(Boolean).map(String).join(" ");
};

/**
 * Flattens EditorJS content into plain text - enough to brief an image model on what a material is
 * about. Code blocks are skipped on purpose; they describe nothing visual.
 */
export const extractPlainText = (content: OutputData | null | undefined, maxLength = 3000): string => {
  if (!content?.blocks?.length) {
    return "";
  }

  return content.blocks
    .filter((block) => block.type !== "code" && block.type !== "raw")
    .map((block) => stripHtml(blockToText(block)))
    .filter(Boolean)
    .join("\n")
    .slice(0, maxLength);
};
